import React from 'react';
import { useSelector } from 'react-redux';

import LoadingPage from 'common/components/LoadingPage';
import NextRewardRateCard from '../NextRewardRateCard';
import BalanceCard from '../BalanceCard';
import UnlockScheduleCard from '../UnlockScheduleCard';
import { selectors } from '../../index';

import styles from './index.module.css';

const RewardsContent = () => {
  const isFetchingRewards = useSelector(selectors.isFetchingRewards);
  const rewardsData = useSelector(selectors.rewardsData);

  if (isFetchingRewards || !rewardsData) {
    return <LoadingPage />;
  }

  return (
    <div className={styles.root}>
      <div className={styles.leftColumn}>
        <NextRewardRateCard
          rate={rewardsData.nextRewardRate.rate}
          description={rewardsData.nextRewardRate.description}
        />
        <BalanceCard balance={rewardsData.balance} />
      </div>
      <div className={styles.rightColumn}>
        <UnlockScheduleCard schedule={rewardsData.schedule} />
      </div>
    </div>
  );
};

export default RewardsContent;
